import React, { useState, useEffect } from 'react';
import { setAddressData } from '../../../../../redux/checkoutredux/actions/checkoutactions/checkoutActions';
import BlockDeliveryMehod from "./BlockDeliveryMehod";


const BlockAddress = ({store}) => {
  //const [addressData, setAddressDataLocally] = useState(store.getState().adressdatacurrent.addressData);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [isCollapsed2, setIsCollapsed2] = useState(true);

  // const shippingmethods = store.getState().deliverymethods;
  //const shippingmethods = store.getState().shoppingcart.metacartdata[0].shippingmethods;
  console.log("ADDRESSDATA START: ",store.getState().addressdatacurrent);
  const checkoutsteps = store.getState().checkoutsettings.checkoutSettings.checkout_steps;

  const [addressData, setAddressDataLocally] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    street: '',
    houseNumber: '',
    additionalInfo: '',
    country: '',
    state: '',
    zip: '',
    city: '',
    phone: ''
  });



  let shippingmodul = null;
  if (checkoutsteps === 'select2') {
    shippingmodul = (
      <>        
     <div className="my-4"><BlockDeliveryMehod store={store}/></div>

      </>
    );
  }


  //console.log("Initialdata: ",initialAddressData);
  

  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed); // Zustand umkehren, wenn der Button geklickt wird
  };

  const handleToggleCollapse2 = () => {
    setIsCollapsed2(!isCollapsed2); // Zustand umkehren, wenn der Button geklickt wird
  };


  
  useEffect(() => {
    const initialAddressData = store.getState().addressdatacurrent?.addressData || {};
    setAddressDataLocally(initialAddressData);

    const unsubscribe = store.subscribe(() => {
      const currentState = store.getState();
      if (currentState.addressdatacurrent) {
        setAddressDataLocally(currentState.addressdatacurrent.addressData || {});
      }
    });

    return unsubscribe;
  }, [store]);

  /*
  const [addressData, setAddressDataLocally] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    street: '',
    houseNumber: '',
    additionalInfo: '',
    country: '',
    state: '',
    zip: '',
    city: '',
    phone: ''
  });

  */


/*
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setAddressDataLocally({ ...addressData, [id]: value });
    store.dispatch(setAddressData({ ...addressData, [id]: value }));
  };
  */


const handleInputChange = (e) => {
  console.log("handleinput");
  let { id, value } = e.target;
  let updatedAddressData = { ...addressData, [id]: value };
  setAddressDataLocally(updatedAddressData);
  store.dispatch(setAddressData(updatedAddressData));

 

};

  console.log("ADDRESSDATA: ",addressData);
  
  return (
    <form className="checkout-sub woocommerce-checkout needs-validation" noValidate>
      <div id="ips-address-details" className="ips-module ips-checkout-body-color">
        <div className="row g-3 py-4">
         {/* <h4 className="mb-3">Lieferanschrift</h4> */}
          <div className="col-sm-6">
            <input type="text" className="form-control" id="firstName" placeholder="Vorname" required value={addressData.firstName} onChange={handleInputChange} />
            <div className="invalid-feedback">Ein gültiger Vorname ist erforderlich.</div>
          </div>
          <div className="col-sm-6">
            <input type="text" className="form-control" id="lastName" placeholder="Nachname" required value={addressData.lastName} onChange={handleInputChange} />
            <div className="invalid-feedback">Ein gültiger Nachname ist erforderlich.</div>
          </div>




        {/* Bootstrap-Collapse-Element 1 hier einfügen */}
  
    <div className="row ips-input-wrap-row">
        <p className="form-row ips-hidden col-lg-12 ips-text-input ips-input-wrap" id="shipping_company_field" data-priority="">
          <label htmlFor="shipping_company" className="ips-floatable-label">Firmenname <span className="optional">(optional)</span></label>
          <span className="woocommerce-input-wrapper">
            <input type="text" className="input-text update_totals_on_change garlic-auto-save" name="shipping_company" id="shipping_company" placeholder="Firmenname (optional)" value="" data-saved-value="IPS_EMPTY" autoComplete="organization" />
          </span>
        </p>

          {/* Abhängig vom Zustand den Text des Buttons ändern */}
          {isCollapsed ? (
                    <a href="dontjump:" className="ips-checkout-small ips-add-field form-row " onClick={handleToggleCollapse}>
           
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg> Unternehmen hinzufügen (optional)
              </a>
          ) : (
          <></>
          )}
      
      </div>

      {/* Dynamisches Ein- und Ausblenden des Bootstrap-Collapse-Elements basierend auf dem Zustand */}
      <div className={`col-12 ${isCollapsed ? 'collapse' : ''}`} id="collapseCompany">
        <input type="text" className="card form-control" id="companyName" placeholder="Firmenname" value={addressData.companyName} onChange={handleInputChange} />
        <div className="invalid-feedback">Bitte geben Sie einen gültigen Firmennamen ein.</div>
      </div>
        {/* Ende des Bootstrap-Collapse-Elements */}





 {/* 
          <div className="col-12">
            <input type="text" className="form-control" id="companyName" placeholder="Firmenname" value={addressData.companyName} onChange={handleInputChange} />
            <div className="invalid-feedback">Bitte geben Sie einen gültigen Firmennamen ein.</div>
          </div>
          */}

          <div className="col-sm-8">
            <input type="text" className="form-control" id="street" placeholder="Straße" required value={addressData.street} onChange={handleInputChange} />
            <div className="invalid-feedback">Bitte geben Sie Ihre Lieferadresse ein.</div>
          </div>

          <div className="col-sm-4">
            <input type="text" className="form-control" id="houseNumber" placeholder="Hausnummer" value={addressData.houseNumber} onChange={handleInputChange} />
          </div>










        {/* Bootstrap-Collapse-Element 2 hier einfügen */}
  
        <div className="row ips-input-wrap-row">
        <p className="form-row ips-hidden col-lg-12 ips-text-input ips-input-wrap" id="shipping_company_field" data-priority="">
          <label htmlFor="shipping_company" className="ips-floatable-label">Zusatz (Wohnung, Zimmer, Etage) <span className="optional">(optional)</span></label>
          <span className="woocommerce-input-wrapper">
            <input type="text" className="input-text update_totals_on_change garlic-auto-save" name="shipping_company" id="addionial_address_info" placeholder="Zusatz (Wohnung, Zimmer, Etage)" value="" data-saved-value="IPS_EMPTY" autoComplete="organization" />
          </span>
        </p>

          {/* Abhängig vom Zustand den Text des Buttons ändern */}
          {isCollapsed2 ? (
                    <a href="dontjump:" className="ips-checkout-small ips-add-field form-row " onClick={handleToggleCollapse2}>
           
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg> Adresse hinzufügen Zeile 2 (optional)
              </a>
          ) : (
          <></>
          )}
      
      </div>

      {/* Dynamisches Ein- und Ausblenden des Bootstrap-Collapse-Elements basierend auf dem Zustand */}
      <div className={`col-12 ${isCollapsed2 ? 'collapse' : ''}`} id="collapseadditionalinfo">
        <input type="text" className="card form-control" id="additionalInfo" placeholder="Zusatz (Wohnung, Zimmer, Etage)" value={addressData.additionalInfo} onChange={handleInputChange} />
        <div className="invalid-feedback">Bitte geben Sie Zusatzinfos an.</div>
      </div>
        {/* Ende des Bootstrap-Collapse-Elements */}











        {/* Bootstrap-Collapse-Element 2 old hier einfügen */}
         {/* 
        <div className="row ips-input-wrap-row">
          <p className="form-row ips-hidden col-lg-12 ips-text-input ips-input-wrap" id="shipping_company_field" data-priority="">
            <label htmlFor="shipping_company" className="ips-floatable-label">Zusatz (Wohnung, Zimmer, Etage) <span className="optional">(optional)</span></label>
            <span className="woocommerce-input-wrapper">
              <input type="text" className="input-text update_totals_on_change garlic-auto-save" name="shipping_company" id="shipping_company" placeholder="Firmenname (optional)" value="" data-saved-value="IPS_EMPTY" autoComplete="organization" />
            </span>
          </p>
          <a href="dontjump" className="ips-checkout-small ips-add-field form-row " data-bs-toggle="collapse" data-bs-target="#collapseadditionalinfo" aria-expanded="false" aria-controls="collapseadditionalinfo">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg> Adresse hinzufügen Zeile 2 (optional)
          </a>
        </div>

        <div className="col-12 collapse" id="collapseadditionalinfo">
      
            
            <input type="text" className="card form-control" id="additionalInfo" placeholder="Zusatz (Wohnung, Zimmer, Etage)" value={addressData.additionalInfo} onChange={handleInputChange} />
            <div className="invalid-feedback">Bitte geben Sie Zusatzinfos an.</div>
           
          </div>
          */}
        {/* Ende des Bootstrap-Collapse-Elements */}


  {/* 
          <div className="col-12">
            <input type="text" className="form-control" id="additionalInfo" placeholder="Zusatz (Wohnung, Zimmer, Etage)" value={addressData.additionalInfo} onChange={handleInputChange} />
            <div className="invalid-feedback">Bitte geben Sie Zusatzinfos an.</div>
          </div>
          */}

          <div className="col-md-5">
            <select className="form-select" id="country" required value={addressData.country} onChange={handleInputChange}>
              <option value="">Land auswählen...</option>
              <option>Vereinigte Staaten</option>
            </select>
            <div className="invalid-feedback">Bitte wählen Sie ein gültiges Land aus.</div>
          </div>
          <div className="col-md-4">
            <select className="form-select" id="state" required value={addressData.state} onChange={handleInputChange}>
              <option value="">Bundesland auswählen...</option>
              <option>Kalifornien</option>
            </select>
            <div className="invalid-feedback">Bitte geben Sie einen gültigen Status an.</div>
          </div>

          <div className="col-md-3">
            <input type="text" className="form-control" id="zip" placeholder="Postleitzahl" required value={addressData.zip} onChange={handleInputChange} />
            <div className="invalid-feedback">Postleitzahl erforderlich.</div>
          </div>

          <div className="col-12">
            <input type="email" className="form-control" id="city" placeholder="Ort/Stadt" value={addressData.city} onChange={handleInputChange} />
            <div className="invalid-feedback">Bitte geben Sie den Ort/Stadt an.</div>
          </div>

          <div className="col-12">
            <input type="email" className="form-control" id="phone" placeholder="Telefon" value={addressData.phone} onChange={handleInputChange} />
            <div className="invalid-feedback">Bitte geben Ihre Telefonnummer ein.</div>
          </div>
        </div>
      </div>
      {shippingmodul}
    </form>
  );
};

export default BlockAddress;